import { useTranslation } from 'react-i18next'

export const usePageTitle = (pageTitle: unknown): string => {
  const { t } = useTranslation()
  if (typeof pageTitle === 'string') {
    return `${t(pageTitle)}` // ${t('common.appTitle')} -
  }
  return t('common.appTitle')
}
